/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkKeywordDTO
 */
export interface WorkKeywordDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkKeywordDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkKeywordDTO
     */
    keyword?: string;
}

/**
 * Check if a given object implements the WorkKeywordDTO interface.
 */
export function instanceOfWorkKeywordDTO(value: object): value is WorkKeywordDTO {
    return true;
}

export function WorkKeywordDTOFromJSON(json: any): WorkKeywordDTO {
    return WorkKeywordDTOFromJSONTyped(json, false);
}

export function WorkKeywordDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkKeywordDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'keyword': json['keyword'] == null ? undefined : json['keyword'],
    };
}

export function WorkKeywordDTOToJSON(json: any): WorkKeywordDTO {
    return WorkKeywordDTOToJSONTyped(json, false);
}

export function WorkKeywordDTOToJSONTyped(value?: WorkKeywordDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'keyword': value['keyword'],
    };
}


